import { ProgressBar } from 'baseui/progress-bar'
import { StyledCode, StyledCodeBox, StyledCodeExpiry } from './styled-components'
import useRegistrationCode from './useRegistrationCode'

export interface RegistrationCodeProps {
  hidden: boolean
  code: string
  expired: boolean
  expiryLabel: string
  progress: { value: number; maxValue: number }
}

const RegistrationCode = ({ hidden, code, expired, expiryLabel, progress }: RegistrationCodeProps) => {
  const { isPulse, progressOverrides } = useRegistrationCode()

  if (hidden) {
    return null
  }

  return (
    <StyledCodeBox $pulse={isPulse}>
      <StyledCode $pulse={isPulse} $expired={expired}>
        {code}
      </StyledCode>
      <StyledCodeExpiry $pulse={isPulse} $expired={expired}>
        {expiryLabel}
      </StyledCodeExpiry>
      <ProgressBar value={progress.value} maxValue={progress.maxValue} overrides={progressOverrides} />
    </StyledCodeBox>
  )
}

export default RegistrationCode
